<label
    id="pontic-designs"
    class="pontic-design-label"
    [ngClass]="{'read-only-label': isReadonly, 'disabled-label': control?.disabled}"
    *ngIf="showLabel"
    >{{ 'Pontic Design' | translate }}
</label>
<div
    [id]="'pontic-designs-radio-group'"
    aria-labelledby="pontic-designs"
    [class.read-only]="isReadonly"
    class="pontic-selector rx-app-flex-container-row rx-app-flex-container-row--justify-space-between rx-app-flex-container-row--align-end"
>
    <div
            [id]="'pontic-design-wrapper-' + option?.Id"
            [matTooltip]="option?.Name"
            [matTooltipPosition]="'below'"
            class="pontic-container"
            *ngFor="let option of optionsWithDefault"
    >
        <tlk-radio-button
                [value]="option"
                [name]="name || 'pontic-designs'"
                [checked]="isChecked(option)"
                [disabled]="isReadonly || control?.disabled"
                class="pontic-selector_button"
                [class.read-only]="isReadonly"
                [labelPosition]="'top'"
                (_change)="onOptionSelect(option)"
        >
            <a class="default-option-label" *ngIf="!option">{{ 'ToothEditor.NA' | translate }}</a>
            <img *ngIf="option" [src]="option | mapper : getSrcForPonticDesignImage.bind(this)" [alt]="option?.Name" />
        </tlk-radio-button>
    </div>
</div>
